import React from 'react';

export const CallbackPage = () => <span id='oidcProvider_callbackSuccessComponent'></span>;
